import React, { PureComponent } from "react";
import { Row, Col, TreeSelect } from 'antd';
import { Form, Input, Select, Upload, Message, Radio, Layout, Button, DatePicker } from 'element-react';
import "./opinionsMailbox.scss";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import img from "../../img/home/characteristic/img1.png";
import 'element-theme-default';

export default class opinionsMailbox extends PureComponent {
  constructor(props) {
    super(props);
    this.uploadRef = React.createRef();
    this.state = {
      userType: 1, //用户类型：1士兵，2干部，3优抚对象
      dicts: [],
      veriCodeImg: '',
      veriCodeAns: '',
      enlistmentTimeOut: '',
      retirementTimeOut: '',

      attachmentNameOut: '',
      attachmentPathOut: '',
      form: {
        attachmentName: '',
        attachmentPath: '',
        name: '',
        sex: '',
        age: '',
        communistStatus: '',
        nation: '',
        education: '',
        idNumber: '',
        permanentAddress: '',
        postalAddress: '',
        enlistmentTime: '',
        retirementTime: '',
        presentSituation: '',
        practiceType: '',

        registeredResidenceType: '',
        retiredSoldierType: '',
        soldiersResettlementMode: '',
        workSituation: '',

        rank: '',
        cadreResettlementMode: '',

        preferentialTreatmentObjectStatus: '',
        preferentialTreatmentObjectCategory: '',
        messageTitle: '',
        messageBody: '',
        businessCategory: '',
        email: '',
        contactNumber: '',
        veriCode: '',
        fileOut: '',
        fileListOut: '',
      },
    };
  }

  componentDidMount() {
    const idVal = Request.GetUrlParam('id');//获取地址栏参数
    Http.get(Request.directormailboxDetail(), { "id": idVal }, obj => {
      console.log('directormailboxDetail---', obj)
      if (obj) {
        this.setState({
          form: obj.data
        })
      }
    });

  }



  render() {
    const { form, userType } = this.state;
    return (
      <div className="complaint-container">
        <fieldset disabled>

          <Form ref="form" model={form} labelWidth="80" className="demo-ruleForm">
            <Row gutter={8}>
              <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
                <span className="title">厅长信箱详情</span>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="姓名" props="name">
                  <Input value={form.name} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="性别" props="sex">
                  <Input value={form.sexName} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="年龄" props="age">
                  <Input value={form.age} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="是否党员" props="communistStatus">
                  <Input value={form.communistStatus == '1' ? '是' : '否'} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="民族" props="nation">
                  <Input value={form.nation} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="学历" props="education">
                  <Input value={form.educationName} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="身份证号" props="idNumber">
                  <Input value={form.idNumber} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="户籍地址" props="permanentAddress">
                  <Input value={form.permanentAddress} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="通讯地址" props="postalAddress">
                  <Input value={form.postalAddress} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="电子邮箱" props="email">
                  <Input value={form.email} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="手机号码" props="contactNumber">
                  <Input value={form.contactNumber} ></Input>
                </Form.Item>
              </Col>

              <Col sm={{ span: 6 }}>
                <Form.Item label="入伍时间" props="enlistmentTime">
                  <Input value={form.enlistmentTime} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="退役时间" props="retirementTime">
                  <Input value={form.retirementTime} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="现状" props="presentSituation">
                  <Input value={form.presentSituationName} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="从业类型" props="practiceType">
                  <Input value={form.practiceTypeName} ></Input>
                </Form.Item>
              </Col>

              <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
                <span className="title">用户类型：</span>
                {/* <Radio.Group onChange={this.onTypeChange.bind(this)} value={userType}>
                <Radio value={1}>士兵</Radio>
                <Radio value={2}>干部</Radio>
                <Radio value={3}>优抚对象</Radio>
              </Radio.Group> */}
              </Col>
              {userType == 1 ? <Col sm={{ span: 24 }} style={{ "display": "flex" }}>
                <Col sm={{ span: 6 }}>
                  <Form.Item label="户籍类型" props="registeredResidenceType">
                    <Input value={form.registeredResidenceTypeName} ></Input>
                  </Form.Item>
                </Col>
                <Col sm={{ span: 6 }}>
                  <Form.Item label="退役兵类型" labelWidth="100" props="retiredSoldierType">
                    <Input value={form.retiredSoldierTypeName} ></Input>
                  </Form.Item>
                </Col>
                <Col sm={{ span: 6 }}>
                  <Form.Item label="安置方式" props="soldiersResettlementMode">
                    <Input value={form.soldiersResettlementModeName} ></Input>
                  </Form.Item>
                </Col>
                <Col sm={{ span: 6 }}>
                  <Form.Item label="工作情况" props="workSituation">
                    <Input value={form.workSituationName} ></Input>
                  </Form.Item>
                </Col>
              </Col> : (userType == 2 ? <Col sm={{ span: 24 }} style={{ "display": "flex" }}>
                <Col sm={{ span: 6 }}>
                  <Form.Item label="职级" props="rank">
                    <Input value={form.rankName} ></Input>
                  </Form.Item>
                </Col>
                <Col sm={{ span: 6 }}>
                  <Form.Item label="安置方式" props="cadreResettlementMode">
                    <Input value={form.cadreResettlementModeName} ></Input>
                  </Form.Item>
                </Col>
              </Col> : <Col sm={{ span: 24 }} style={{ "display": "flex" }}>
                <Col sm={{ span: 7 }}>
                  <Form.Item label="是否优抚对象" labelWidth="120" props="preferentialTreatmentObjectStatus">
                    <Input value={form.preferentialTreatmentObjectStatus == "2" ? '是' : '否'}></Input>
                  </Form.Item>
                </Col>
                <Col sm={{ span: 7 }}>
                  {form.preferentialTreatmentObjectStatus == "2" ? <Form.Item label="优抚对象类别" labelWidth="120" props="preferentialTreatmentObjectCategory">
                    <Input value={form.preferentialTreatmentObjectCategoryName} ></Input>
                  </Form.Item> : null}
                </Col>
              </Col>)}
              <Col sm={{ span: 24 }}>
                <Form.Item label="留言标题" props="messageTitle">
                  <Input value={form.messageTitle} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="留言正文" props="messageBody">
                  <Input
                    type="textarea"
                    autosize={{ minRows: 10, maxRows: 20 }}
                    resize='none'
                    value={form.messageBody}
                  />
                </Form.Item>
              </Col>            
             
              <Col sm={{ span: 6 }}>
                <Form.Item label="业务类别" props="businessCategory">
                  <Input value={form.businessCategoryName} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="附件" props="category">
                  <a target="_blank" href={form.attachmentPath ? form.attachmentPath.replace("blob:", '') : ''}><img src={form.attachmentPath} alt="" width='200px' /></a>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </fieldset>

      </div>
    );
  }
}
